export default __webpack_public_path__ + "4d753c4057e5f4c2265b321147796a7e.png";